import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';

export const StyledSessionTableContainer = styled.div`
    ${() => `
    background: linear-gradient(263.61deg, #FFFFFF 15.63%, rgba(255, 255, 255, 0.5) 94.52%);
    border-radius: 16px;
    box-sizing: border-box;
    position: relative;
`}
`;

export const StyledSessionTableHeader = styled.div`
    ${({ theme }) => `
    background: ${theme.palette.common.white};
    border-radius: 16px 16px 0px 0px;
    padding: 15px 25px;
    display: flex;
    align-items: center;
    column-gap: 10px;
    position: absolute;
    top: -4px;
    left: 0;
    right: 0;
    z-index: 10;
`}
`;

export const StyledSessionTableBody = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    padding: 75px 25px 25px 25px;
    border-radius: 16px;
    height: 700px;
    overflow-y: auto;
`}
`;

export const StyledDayContainer = styled.div`
    ${({ theme, $size, $backgroundColor }) => `
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${$size ? $size : '34px'};
    height:${$size ? $size : '34px'};
    background-color: ${
        $backgroundColor ? theme.palette.common[$backgroundColor] : theme.palette.common.purple
    };
    border-radius: 50%;

`}
`;

export const RowContainer = styled.div`
    ${({ theme }) => `
    display: grid;
    align-items: start;
    grid-template-columns: 110px 1fr;
    padding: 5px 5px 5px 0;
    border-bottom: 1px solid ${theme.palette.common.gray4};
`}
`;

export const StyledPatientListContainer = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    `}
`;

export const StyledPatientContainer = styled.div`
    ${({ theme, layout }) => `
    display: grid;
    grid-template-columns:  ${
        layout === 'NEXT_GROUP'
            ? '48px 200px auto 50px'
            : layout === 'ONE_ON_ONE'
            ? '48px 200px 150px auto auto 50px'
            : '48px 200px 150px auto 50px'
    };
    align-items: center;
    column-gap: 10px;

    border: 1px solid ${theme.palette.common.blue1};
    border-radius: 16px;  
    padding: 5px 15px;  
    `}
`;

export const StyledMeetDataContainer = styled.div`
    ${({ selected }) => `
    display: grid;
    align-items: center;
    grid-template-columns: 80px auto;
    column-gap: 10px;
    padding-left: 25px;
    padding-right: 25px;
    border-radius: 19px;
    height: 38px;
    margin-left: 5px;
    margin-right: 10px;

    &:hover {
        background-color: rgba(151, 102, 232, 0.05);
        border-radius: 19px;
    }

    border: 1px solid ${selected ? 'rgba(151, 102, 232, 0.5)' : 'transparent'};
    background-color: ${selected ? 'rgba(151, 102, 232, 0.05)' : 'transparent'};

`}
`;

export const StyledTypeContainer = styled.div`
    ${() => `
    display: flex;
    column-gap: 30px;
    `}
`;

export const StyledRadioContainer = styled.div`
    ${({ disabled }) => `
    display: flex;
    align-items: flex-start;
    column-gap: 10px;

    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    `}
`;

export const StyledRadioTextContainer = styled.div`
    ${() => `
    display: flex;
    flex-direction: column;
    `}
`;

export const useStylesRadio = makeStyles((theme) => ({
    root: {
        padding: 0,
        marginTop: '1px',
        color: theme.palette.common.gray1,
        '&.Mui-checked': {
            color: theme.palette.common.gray1,
        },
    },
}));

export const StyledTypeIndicator = styled.div`
    ${({ theme, $backgroundColor }) => `
    margin-top: 6px;
    height: 10px;
    width: 10px;
    border-radius: 2px;
    background-color: ${theme.palette.common[$backgroundColor]};
    `}
`;
